import _ from 'lodash';
import React, { useCallback, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Link } from 'react-router';
import { submit } from 'redux-form';
import { RaisedButton } from 'material-ui';
import DoneIcon from 'material-ui/svg-icons/action/done';
import KeyboardArrowLeftIcon from 'material-ui/svg-icons/hardware/keyboard-arrow-left';

import { clearPort, addNewPort } from 'actions/regions/ports';
import api from 'services';
import ErrorBoundary from '../../common/ErrorBoundary';
import PortAddForm from './PortAddForm';
import AreaAutoAssignmentConfirmModal from './AreaAutoAssignmentConfirmModal';

const styles = {
    btn: {
        labelStyle: {
            color: '#fff', textTransform: 'none', fontSize: '13px',
        },
        style: {
            margin: '20px 0',
        },
    },
};

/** @type {import('react').FC<any>} */
const PortAdd = ({
    clearPort, addNewPort, submit, router, port, 
}) => {
    const [values, setValues] = useState(null);
    const [areaAssignmentConfirmShown, setAreaAssignmentConfirmShown] = useState(false);

    useEffect(() => () => { // unmount handler
        clearPort();
    }, []);

    useEffect(() => {
        // A new ID appear in the store when a port is created
        if (port._id) {
            router.push(`/regions/ports/${port._id}`);
        }
    }, [port._id]);

    const handleSubmit = useCallback((values, dispatch, props) => {
        setValues(_.cloneDeep(values));
        setAreaAssignmentConfirmShown(true);
    }, []);

    const asyncValidate = useCallback(async (values, dispatch, props) => {
        if (!values.unLoCode) return;
        
        const response = await api.findPortAdmin({ name: values.unLoCode });
        
        if (response.status !== 200 || response.data.data.length === 0) return;

        if (response.data.data[0].unLoCode === values.unLoCode) {
            throw { unLoCode: `unLoCode has been already created into ${response.data.data[0].name}. link - ${location.origin}/regions/ports/${response.data.data[0]._id}` };
        }
    }, []);

    const closeAreaAssignmentConfirm = useCallback((parents) => {
        setAreaAssignmentConfirmShown(false);
        addNewPort({
            ...values,
            country: values.country._id,
            parents,
        });
    }, [values]);

    return (
        <div className='container' id='single-port'>
            <div className="management">
                <div className="btn">
                    <RaisedButton
                        label="Back to list"
                        style={styles.btn.style}
                        labelStyle={styles.btn.labelStyle}
                        labelPosition="before"
                        icon={<KeyboardArrowLeftIcon />}
                        containerElement={<Link to='/regions/ports' />}
                        primary
                    />
                </div>
                <div className="btn">
                    <RaisedButton
                        label="Create port"
                        style={styles.btn.style}
                        labelStyle={styles.btn.labelStyle}
                        labelPosition="before"
                        icon={<DoneIcon />}
                        backgroundColor="#a4c639"
                        onClick={() => submit('port-create')}
                    />
                </div>
            </div>

            <ErrorBoundary>
                <PortAddForm
                    onSubmit={handleSubmit}
                    asyncValidate={asyncValidate}
                />
            </ErrorBoundary>

            <AreaAutoAssignmentConfirmModal
                shown={areaAssignmentConfirmShown}
                onClose={closeAreaAssignmentConfirm}
            />
        </div>
    );
};

PortAdd.displayName = 'PortAdd';

export default connect(
    /** @param {any} param0 */
    ({ port }) => ({
        port,
    }),
    dispatch => bindActionCreators({
        submit,
        clearPort,
        addNewPort,
    }, dispatch),
)(PortAdd);



// WEBPACK FOOTER //
// ./app/components/Regions/PortAdd/Page.jsx